import React, { FC, useEffect, useMemo, useState } from 'react';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { locationsRestCrudThunksForSupplier } from '../../thunks/locations_thunks';
import SupplierLocationPageDisplay from '../supplier_location_page_display/SupplierLocationPageDisplay';
import { getEntityById, nullSafeGet } from '../../utils/DataAccessUtils';

const { Content } = Layout;

require('./SupplierLocationsDetailDetailsPage.less');

const SupplierLocationsDetailPage: FC<any> = ({
	getLocation,
	match,
	location,
	locationsFetching,
}): React.ReactElement => {
	const fetching = locationsFetching && !nullSafeGet('id', location);

	return fetching ? (
		<PageLoadingPlaceholder />
	) : (
		<Content className="supplierLocationsDetailDetailsPage">
			<SupplierLocationPageDisplay
				key={nullSafeGet('id', location)}
				record={location}
				locationsFetching={fetching}
			/>
		</Content>
	);
};

const mapStateToProps = (state, ownProps) => ({
	locationsFetching: state.locations.fetching,
	location: getEntityById(ownProps.match.params.id, state.locations),
	match: ownProps.match,
});

const mapDispatchToProps = (dispatch) => ({
	getLocation: (id) => dispatch(locationsRestCrudThunksForSupplier.readOne(id)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SupplierLocationsDetailPage)
);
